import { defineStore } from "pinia";
import schema from "@/http/apollo/schema";

export const useAccountStore = defineStore("accountStore", {
  state: () => ({
    loaded: false,
    verifiedAccountDialog: false,
    verificationAlert: false,
    user: {},
    userVerified: false,
    loadingUser: true,
  }),

  getters: {
    verifiedCompanyUser(state) {
      const { company, companyVerifiedAt } = state.user;
      return company && !!companyVerifiedAt;
    },

    isento(state) {
      const ie = state.user?.stateRegistration;
      return !ie || ie === "ISENTO";
    },
  },

  actions: {
    setVerifiedAccountDialog(value) {
      this.verifiedAccountDialog = value;
    },

    async loadInitialUserData() {
      if (this.loaded) {
        return;
      }
      try {
        const { data } = await globalThis.$apollo.query({
          query: schema.user.ME,
        });
        this.user = data.me;
        this.userVerified = !!data.me?.emailVerifiedAt;
      } catch {
        // ignore
      } finally {
        this.loaded = true;
      }
    },

    handleUserDetails(data) {
      const prevUser = JSON.parse(JSON.stringify(this.user));
      if (data === null) {
        this.user = {};
        this.userVerified = false;
        setTimeout(() => {
          prevUser.id && globalThis.$events.$emit("user-change");
        }, 100);
      } else if (data) {
        this.user = data.me;
        this.userVerified = !!data.me?.emailVerifiedAt;
        setTimeout(() => {
          !prevUser.id && globalThis.$events.$emit("user-change");
        }, 100);
      }
      this.loadingUser = false;
    },

    async getUserDetails() {
      try {
        const { data } = await globalThis.$apollo.query({
          query: schema.user.ME,
        });
        this.handleUserDetails(data);
      } catch {
        this.handleUserDetails(null);
      } finally {
        this.loadingUser = false;
      }
    },
  },
});
